import Divider from './src/main'

/* istanbul ignore next */
Divider.install = function(Vue) {
  Vue.component(Divider.name, Divider)
}

export default Divider
